import React from "react";
import "./style.scss";
import { useTranslation } from "locales";
import BaseIcon from "components/BaseIcon";

export default function BlockOurValues() {
  const { t } = useTranslation();

  const cards = [
    {
      title: t("Integrity in Everything"),
      description: t("We act with honesty, transparency, and accountability in all relationships."),
      icon: "heart",
    },
    {
      title: t("Excellence as Standard"),
      description: t("We deliver the highest quality in coaching, service, and outcomes."),
      icon: "star-outline",
    },
    {
      title: t("Impact Driven"),
      description: t("Every action is measured by the tangible results we create for students and institutions."),
      icon: "trending-up",
    },
    {
      title: t("Inclusive Partnerships"),
      description: t("We open doors for all talent and succeed through collaboration"),
      icon: "users",
    },
    {
      title: t("Innovation with Purpose"),
      description: t("We evolve and improve continuously to meet the real needs of the market."),
      icon: "zap",
    },
  ];

  return (
    <div className="block-our-values">
      <h2 className="block-our-values__title h1 mb-4 text-center mx-auto mt-10">{t("Our values")}</h2>
      <div className="block-our-values__description subtitle-1 text-neutral-darken-1 mb-10 text-center mx-auto">
        {t("Values that guide how we collaborate, coach, and create opportunities for all.")}
      </div>
      <div className="block-our-values__card-wrapper d-flex __wrap __justify-center">
        {cards.map((card, index) => (
          <div
            key={index}
            className="block-our-values__card box-shadow d-flex __column __align-center pa-6 text-center"
          >
            <div className="block-our-values__card-icon d-center mb-3">
              <BaseIcon size={32}>{card.icon}</BaseIcon>
            </div>
            <div className="caption-1 fw-bold mb-1">{card.title}</div>
            <div className="body-2 text-neutral-darken-1">{card.description}</div>
          </div>
        ))}
      </div>
    </div>
  );
}
